export default __webpack_public_path__ + "static/media/me3-V2 [English].c1ad22d9.mp4";